import { getUserToken } from '@/utils'
import axios from 'axios'
import { baseApi } from '../config'
import { Toast } from 'vant'
import store from '@/store'
import router from '@/router'
import { routerJump } from '@/views/ksH5RealName/server/ksH5RealName'

const service = axios.create({
  baseURL: baseApi,
  // baseURL: '',
  timeout: 1000 * 60 * 10, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    // config.headers = {
    //   ...config.headers,
    //   Platform: 3,
    //   Version: '2.4.0',
    // }
    // 特殊处理 快手H5电商实名认证专用 请求中提示，因为有老的项目在里面，我不知道别的项目是否有自己处理加载中提示，所以只针对我需要做处理
    if (config.isToast) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
    }
    config.headers.Platform = 5
    config.headers.Version = '2.4.0'
    let token = ''
    if (config.tokenKey === 'ksH5token') {
      token = localStorage.getItem('ksH5token')
    } else {
      token = getUserToken()
    }
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => {
    Promise.reject(error)
  },
)

// respone拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    if (response.data.code !== 200) {
      // 特殊处理 快手H5电商实名认证专用 start 处理错误提示，因为有老的项目在里面，我不知道别的项目是否有自己处理错误提示，所以只针对我需要做处理
      if (response.config.isToast) {
        Toast({
          message: response.data.message,
          duration: 2000,
        })
      }
      // 特殊处理 快手H5电商实名认证专用 end
      return Promise.reject(
        Error(
          JSON.stringify({
            code: response.data.code,
            message: response.data.message,
          }),
        ),
      )
    }
    return response.data.data
  },
  error => {
    let err =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : ''
    if (!err && error && error.response) {
      switch (error.response.status) {
        case 400:
          err = '错误请求'
          break
        case 401:
          err = '未授权，请重新登录'
          break
        case 403:
          err = '拒绝访问'
          break
        case 404:
          err = '请求错误,未找到该资源'
          break
        case 405:
          err = '请求方法未允许'
          break
        case 408:
          err = '请求超时'
          break
        case 422:
          err = error.response.data.message
          break
        case 500:
          err = '服务器端出错'
          break
        case 501:
          err = '网络未实现'
          break
        case 502:
          err = '网络错误'
          break
        case 503:
          err = '服务不可用'
          break
        case 504:
          err = '网络超时'
          break
        case 505:
          err = 'http版本不支持该请求'
          break
        default:
          err = '连接错误' + error.response.data.message
      }
    }
    if (!err) {
      err = '未知错误，请联系管理员'
    }
    // 特殊处理 快手H5电商实名认证专用 start 处理错误提示，因为有老的项目在里面，我不知道别的项目是否有自己处理错误提示，所以只针对我需要做处理
    if (error.config.isToast && error.response.status !== 401) {
      Toast({
        message: err,
        duration: 2000,
      })
    }
    if (
      error.response.status === 401 &&
      error.config.tokenKey === 'ksH5token'
    ) {
      store.commit('user/clearUserInfo')
      routerJump('/ksH5RealName')
    }
    // 特殊处理 快手H5电商实名认证专用 end
    return Promise.reject(err)
  },
)

export default service
